import { render, staticRenderFns } from "./InputGroupLabel.vue?vue&type=template&id=1f774ef9&"
import script from "./InputGroupLabel.vue?vue&type=script&lang=js&"
export * from "./InputGroupLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports